import app from 'flarum/common/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Avatar from 'flarum/common/components/Avatar';
import Icon from 'flarum/common/components/Icon';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
import Link from 'flarum/common/components/Link';
import extractText from 'flarum/common/utils/extractText';
export default class TopPostersWidget extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.monthlyCounts = app.forum.attribute('fof-top-posters-widget.topPosterCounts');
    this.rawMonthlyCounts = app.forum.attribute('fof-top-posters-widget.topPosterRawCounts') || {};
    this.loadWithInitialResponse = app.forum.attribute('fof-forum-widgets-core.preferDataWithInitialLoad');
    this.attrs.state.users ??= [];
    this.attrs.state.isLoading ??= true;
    this.attrs.state.hasLoaded ??= false;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    if (!this.attrs.state.hasLoaded) {
      this.load();
    }
  }
  className() {
    return 'FoF-TopPostersWidget';
  }
  icon() {
    return 'fas fa-sort-numeric-down';
  }
  title() {
    return extractText(app.translator.trans('fof-top-posters-widget.forum.widget.title'));
  }
  description() {
    return '';
  }
  content() {
    if (this.attrs.state.isLoading) {
      return m(LoadingIndicator, null);
    }
    if (this.attrs.state.loadFailed) {
      return m("p", {
        className: "FoF-TopPostersWidget-error"
      }, app.translator.trans('fof-top-posters-widget.forum.widget.load_error'));
    }
    const users = this.attrs.state.users.sort((a, b) => (this.rawMonthlyCounts[b.id()] ?? 0) - (this.rawMonthlyCounts[a.id()] ?? 0));
    return m("div", {
      className: "FoF-TopPostersWidget-users"
    }, users.map(user => m(Link, {
      href: app.route('user', {
        username: user.slug()
      }),
      className: "FoF-TopPostersWidget-users-item"
    }, m("div", {
      className: "FoF-TopPostersWidget-users-item-avatar"
    }, m(Avatar, {
      user: user
    })), m("div", {
      className: "FoF-TopPostersWidget-users-item-content"
    }, m("div", {
      className: "FoF-TopPostersWidget-users-item-name"
    }, user.displayName()), m("div", {
      className: "FoF-TopPostersWidget-users-item-value"
    }, m(Icon, {
      name: "fas fa-comment-dots"
    }), " ", this.monthlyCounts[user.id()])))));
  }
  load() {
    if (this.loadWithInitialResponse) {
      this.setResults(app.forum.topPosters());
      return;
    }
    this.attrs.state.isLoading = true;
    this.attrs.state.loadFailed = false;
    app.store.find('users', {
      filter: {
        top_poster: 'true'
      }
    }).then(users => this.setResults(users), () => {
      // `hasLoaded` stays false, so the next time the widget is shown it tries again.
      this.attrs.state.isLoading = false;
      this.attrs.state.loadFailed = true;
      m.redraw();
    });
  }
  setResults(users) {
    this.attrs.state.users = users;
    this.attrs.state.isLoading = false;
    this.attrs.state.hasLoaded = true;
    m.redraw();
  }
}
flarum.reg.add('fof-top-posters-widget', 'common/components/TopPostersWidget', TopPostersWidget);